import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Dashboard } from '@core/models';
import { endpoints, environment } from '@environment';
import { Observable } from 'rxjs';
import { suppressGlobalErrorFeedback } from '@core/interceptors';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/${endpoints.v1.dashboard}`;

  getDashboard(dateFrom: string, dateTo: string): Observable<Dashboard> {
    const params = new HttpParams().set('dateFrom', dateFrom).set('dateTo', dateTo);
    return this.http.get<Dashboard>(this.baseUrl, { params, context: suppressGlobalErrorFeedback() });
  }
}
